<template>
  <div>
    <el-dialog
      :title="params.id ? '图片编辑' : '图片添加'"
      :visible="showPopup"
      width="800px"
      :modal-append-to-body="false"
      @close="close"
    >
      <el-form
        :model="params"
        :rules="rules"
        label-width="120px"
        ref="coverFormRef"
      >
        <el-form-item label="图片：" prop="coverImageUrl">
          <el-upload
            :class="[
              'avatar-uploader',
              params.coverImageType === getOrientationEnum.vertical
                ? 'vertical'
                : 'horizontal'
            ]"
            :action="actionUrl"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <el-image
              v-if="params.coverImageUrl"
              :src="params.coverImageUrl"
              class="avatar"
              fit="scale-down"
            />
            <i v-else class="el-icon-plus avatar-uploader-icon" />
          </el-upload>
        </el-form-item>
        <el-form-item label="图片样式：" prop="coverImageType">
          <el-radio-group v-model="params.coverImageType">
            <el-radio
              v-for="item in getOrientationList"
              :key="item.value"
              :label="item.value"
              >{{ item.label }}</el-radio
            >
          </el-radio-group>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="saveCover" type="primary">保 存</el-button>
        <el-button @click="close">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { orientationList, orientationEnum } from "./coverListOption";

export default {
  name: "addCoverPopup",
  data() {
    return {
      showPopup: false,
      params: {
        coverImageType: 1
      },
      rules: {
        coverImageUrl: [
          { required: true, message: "请上传文件", trigger: "change" }
        ]
      },
      actionUrl:
        process.env.VUE_APP_BASE_URL +
        "/lebo-resource/oss/endpoint/put-file?code=lebotob" // 上传图片地址
    };
  },
  computed: {
    getOrientationList() {
      return orientationList;
    },
    getOrientationEnum() {
      return orientationEnum;
    }
  },
  methods: {
    show(row) {
      this.params = {
        coverImageType: 1,
        ...row
      };
      this.showPopup = true;
    },
    close() {
      this.showPopup = false;
    },
    // 上传图片前校验
    beforeAvatarUpload(file) {
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/jpg" ||
        file.type === "image/png";
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        this.$message.error("只能上传jpg、jpeg或png格式的图片");
        return false;
      }
      if (!isLt5M) {
        this.$message.error("文件大小不能超过5MB");
        return false;
      }

      return isJPG && isLt5M;
    },
    // 上传成功
    handleAvatarSuccess(res) {
      this.$nextTick(() => {
        this.$set(this.params, "coverImageUrl", res.data.link);
      });
    },
    // 保存
    saveCover() {
      this.$refs.coverFormRef.validate(async valid => {
        if (valid) {
          this.$set(this.params, "updateTime", this.getCurrentTime());
          this.$emit("updateCover", this.params);
          this.close();
        }
      });
    },
    // 获取当前时间字符串
    getCurrentTime() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, "0");
      const day = String(now.getDate()).padStart(2, "0");
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
  }
};
</script>
<style lang="scss" scoped>
.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  height: 178px;
  display: flex;
  justify-content: center;

  ::v-deep .el-upload {
    width: 100%;
    height: 100%;
    text-align: -webkit-center;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: auto;
    height: 178px;
    display: block;
  }

  &:hover {
    border-color: #409eff;
  }
}

.vertical {
  width: 118px;

  .avatar-uploader-icon {
    width: 118px;
  }
}

.horizontal {
  width: 430px;

  .avatar-uploader-icon {
    width: 430px;
  }
}
</style>
